import React from 'react';
import R from 'ramda';
import PropTypes from 'prop-types';
import Heading from '@cotyorg/ccx-atoms/Heading';
import { CardoGroup } from '@cotyorg/ccx-organism-cardo-group';
import SectionHeader from '../../../../atoms/SectionHeader';
import {
  benefitsBaseCardoConfig,
  benefitsEveryNthBreakpointConfig,
} from './cardo.config';

export const BenefitsSection = ({ sectionHeadings }) => (
  <div className="benefits-section">
    <div className="grid-container">
      <div className="grid-x grid-margin-x">
        <div className="cell">
          <SectionHeader>
            <Heading extraClass="section__title" level={2}>
              {R.path(['benefits', 'heading'])(sectionHeadings)}
            </Heading>
          </SectionHeader>
        </div>
      </div>

      <div className="benefits-section__icons grid-x grid-padding-x flex-container align-middle">
        <CardoGroup
          data="cardSection1Cards"
          contentTheme="transparent"
          baseBreakpointConfig={benefitsBaseCardoConfig}
          everyNthBreakpointConfig={benefitsEveryNthBreakpointConfig}
        />
      </div>
    </div>
  </div>
);

BenefitsSection.propTypes = {
  sectionHeadings: PropTypes.instanceOf(PropTypes.object),
};
